/**
 * Testi italiani della pagina Impostazioni (ADR 0030 §7, tappa 7): preferenze
 * di questo browser, notifiche e privacy.
 */

/** Testi delle impostazioni. */
export const settings = {
  /** Titolo. */
  title: 'Impostazioni',
  /** Che cosa contiene. */
  description: 'Le preferenze di questo browser, le notifiche e come trattiamo i tuoi dati.',

  /** Preferenze generali. */
  general: {
    /** Titolo. */
    title: 'Generale',
    /** Tema. */
    theme: 'Tema',
    /** Lingua. */
    language: 'Lingua',
    /** Tabelle compatte. */
    compact: 'Tabelle compatte',
    /** Aiuto sotto l'interruttore. */
    compactHelp: 'Righe più basse nelle tabelle. Vale solo su questo browser.',
    /** Invio dei messaggi nel relay. */
    send: 'Invio dei messaggi',
    /** Opzione Ctrl+Invio. */
    sendCtrlEnter: 'Ctrl+Invio invia, Invio va a capo',
    /** Opzione Invio. */
    sendEnter: 'Invio invia, Maiusc+Invio o Ctrl+Invio vanno a capo',
    /** Aiuto sotto la scelta. */
    sendHelp: 'Vale per il campo dell’Institore e per il messaggio rapido. Sul Mac Ctrl è Cmd.',
    /** Fuso orario. */
    timeZone: 'Fuso orario',
    /** Opzione «come il browser», con il fuso del browser. */
    timeZoneBrowser: 'Come il browser ({{zone}})',
    /** Aiuto sotto il fuso. */
    timeZoneHelp: 'Date e ore della dashboard sono scritte in questo fuso. Vale solo su questo browser.',
  },

  /** Notifiche. */
  notifications: {
    /** Titolo. */
    title: 'Notifiche',
    /** Campanella. */
    bell: 'La campanella in alto mostra le proposte di task, le analisi da approvare, i set in errore, le credenziali mancanti e gli avvisi sui token del mese. Si aggiorna ogni minuto.',
    /** Telefoni. */
    phones: 'Le notifiche sul telefono arrivano dall’app institor. I telefoni registrati si vedono e si tolgono dal profilo.',
    /** Collegamento ai telefoni. */
    phonesLink: 'Telefoni registrati',
    /** Titolo delle preferenze per evento. */
    eventsTitle: 'Notifiche sul telefono',
    /** Spiegazione delle preferenze. */
    eventsIntro: 'Scegli quali eventi ti avvisano sul telefono. La scelta vale per tutti i tuoi telefoni.',
    /** Etichetta dell'evento. */
    events: {
      relay_response: 'Risposta dell’Institore',
      set_error: 'Errore di un set',
      site_published: 'Sito pubblicato',
      quota_warning: 'Avviso sui token del mese',
      task_proposed: 'Task proposto da un agente',
      runtime_paused: 'Runtime in pausa',
      set_invitation: 'Invito in un set',
      site_alert: 'Avvisi del sito in produzione',
      billing: 'Pagamenti e consumo',
    },
    /** Esito del salvataggio. */
    saved: 'Preferenza salvata.',
    /** Errore di lettura. */
    loadFailed: 'Preferenze non disponibili. Riprova.',
    /** Errore di salvataggio. */
    saveFailed: 'Preferenza non salvata. Riprova.',
  },

  /** Privacy. */
  privacy: {
    /** Titolo. */
    title: 'Privacy',
    /** Messaggi. */
    messages: 'Messaggi, risposte e azioni degli agenti restano nei tuoi set. Li vedi tu e li vedono gli amministratori della piattaforma.',
    /** Trascrizioni. */
    voice: 'Le conversazioni di voce passano da ElevenLabs. Di ogni conversazione teniamo la trascrizione e un riassunto, che trovi nella cronologia.',
    /** Accessi. */
    access: 'Gli accessi al tuo account restano nel registro per 90 giorni.',
    /** Collegamento alla cronologia. */
    historyLink: 'Apri la cronologia',
    /** Collegamento al registro. */
    accessLink: 'Apri il registro accessi',
  },

  /** Esportazione dei propri dati (ADR 0031). */
  dataExport: {
    /** Titolo. */
    title: 'I tuoi dati',
    /** Spiegazione. */
    intro: 'Scarica un archivio con i tuoi dati: profilo, set, messaggi, task, trascrizioni, pagamenti, notifiche, strumenti e accessi. Non contiene password né token.',
    /** Pulsante che avvia la raccolta. */
    request: 'Prepara archivio',
    /** Pulsante per una nuova raccolta. */
    requestAgain: 'Prepara di nuovo',
    /** Raccolta in corso. */
    running: 'Preparazione dell’archivio in corso…',
    /** Archivio pronto. */
    ready: 'Archivio pronto ({{size}}). Il collegamento vale fino a {{until}}.',
    /** Collegamento di scaricamento. */
    download: 'Scarica archivio',
    /** Raccolta fallita. */
    failed: 'Archivio non preparato. Riprova.',
    /** Archivio scaduto. */
    expired: 'L’archivio è scaduto. Preparane uno nuovo.',
    /** Fonti mancanti. */
    missing: 'Mancano i dati di: {{sources}}. Riprova più tardi per un archivio completo.',
    /** Esito della richiesta. */
    requested: 'Preparazione avviata.',
    /** Raccolta già in corso. */
    inProgress: 'C’è già un archivio in preparazione.',
    /** Errore della richiesta. */
    requestFailed: 'Preparazione non avviata. Riprova.',
    /** Errore di lettura dello stato. */
    loadFailed: 'Stato dell’archivio non disponibile. Riprova.',
    /** Nomi delle fonti. */
    sources: {
      agents: 'set e messaggi',
      billing: 'pagamenti',
      notifications: 'notifiche',
      tools: 'strumenti',
      gateway: 'accessi',
    },
  },

  /** Cancellazione dell'account (ADR 0031). */
  deleteAccount: {
    /** Titolo della zona. */
    title: 'Zona pericolosa',
    /** Spiegazione. */
    intro: 'Cancellare l’account ferma e toglie i tuoi set e i tuoi siti, disdice l’abbonamento, cancella connessioni, telefoni e preferenze e disattiva l’accesso. Non si può annullare.',
    /** Cosa resta. */
    kept: 'Restano, per obbligo di legge o di sicurezza: fatture e pagamenti, il registro degli accessi per 90 giorni e la traccia della cancellazione.',
    /** Pulsante che apre la conferma. */
    open: 'Cancella account',
    /** Titolo della conferma. */
    confirmTitle: 'Cancellare l’account?',
    /** Testo della conferma. */
    confirmText: 'Scrivi il tuo nome utente, {{username}}, e la password. Dopo la cancellazione esci subito.',
    /** Testo della conferma per chi è entrato con Google. */
    confirmTextGoogle: 'Scrivi il tuo nome utente, {{username}}. Dopo la cancellazione esci subito.',
    /** Accesso con Google troppo vecchio. */
    reauth: 'Per confermare serve un accesso recente con Google. Accedi di nuovo e riprova.',
    /** Sessione di cui non si sa come è nata. */
    reauthHint: 'Se entri con Google, accedi di nuovo per confermare senza password.',
    /** Pulsante che rifà l'accesso con Google. */
    reauthAction: 'Accedi con Google',
    /** Campo del nome. */
    username: 'Nome utente',
    /** Campo della password. */
    password: 'Password',
    /** Pulsante che conferma. */
    confirm: 'Cancella',
    /** Annulla. */
    cancel: 'Annulla',
    /** Amministratore. */
    admin: 'Un amministratore non può cancellare il proprio account. Chiedi a un altro amministratore.',
    /** Nome diverso. */
    mismatch: 'Il nome utente non coincide.',
    /** Password sbagliata. */
    wrongPassword: 'La password non è corretta.',
    /** Cancellazione incompleta. */
    incomplete: 'Cancellazione non completata. Il tuo account è ancora attivo: riprova fra qualche minuto.',
    /** Errore generico. */
    failed: 'Cancellazione non riuscita. Riprova.',
    /** Esito. */
    done: 'Account cancellato.',
  },
};

/** Forma dei testi delle impostazioni, usata per tipare le altre lingue. */
export type Settings = typeof settings;
